import { Flex } from "@redotech/arbiter/flex";
import { memo, type ReactNode } from "react";

/**
 * Binds a row to the rows that only apply when it has a certain value, so the
 * card draws one divider around the pair instead of separating a parent from
 * its own children. Wrap a row and the `SettingsChildren` beneath it.
 */
export const SettingsNestedRows = memo(function SettingsNestedRows({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <Flex dir="column" gap="none" w="full">
      {children}
    </Flex>
  );
});
